import { MCheckbox, MInput, MSelect } from "components/forms";
import dayjs from "dayjs";
import { dateHelper, formHelper } from "libs";

export class TitoliProfessionaliTFAIndireConfig {
  /**
   *  I campi sono gli stessi
   *  Cambia la validazione dell'aa
   *
   * VALIDAZIONE 75:
   * AA: dal 2017/2018 al 2024/2025
   *
   * VALIDAZIONE 77:
   * AA: nessun limite per gli anni scolastici ma per l’anno 2025/2026 non può esser flaggata l’opzione “Fino al termine delle operazioni di scrutinio finale……” ma deve essere indicata una data di fine
   * massimo uguale alla data di compilazione della domanda. NO DATE FUTURE
   */

  static PAYLOADS = {
    competitionClass: [
      { label: "Seleziona classe di concorso", value: "-1" },
      { label: "ADEE - Sostegno Scuola Primaria", value: "ADEE" },
      { label: "ADMM - Sostegno Scuola Secondaria di I grado", value: "ADMM" },
      { label: "ADSS - Sostegno Scuola Secondaria di II grado", value: "ADSS" },
    ],
    grado: [
      { label: "Seleziona grado", value: "" },
      { label: "Scuola Primaria", value: "PRIMARIA" },
      { label: "Scuola Secondaria di I Grado", value: "I GRADO" },
      { label: "Scuola Secondaria di II Grado", value: "II GRADO" },
    ],
  };

  static default_values = {
    istitution: "",
    city: "",
    grado: "",
    ufficioScolastico: "",
    classeConcorso: "",
    contactEmail: "",
    province: "",
    address: "",
    dateFrom: "",
    dateTo: "",
    durata: "",
    aa: "",
    lode: false,
  };

  static getCompetitionClass = (grado) => {
    switch (grado) {
      case "PRIMARIA":
        return "ADEE";
      case "I GRADO":
        return "ADMM";
      case "II GRADO":
        return "ADSS";
      default:
        return "-1";
    }
  };

  /** FIELDS */

  static getFieldsFull = (props) => [
    [
      {
        id: "istitution" + props.idx,
        field: "istitution",
        label: "Istituzione Scolastica",
        component: MInput,
        className: "col-md-9 pt-3",
      },
      {
        id: "aa" + props.idx,
        field: "aa",
        label: "Anno Scolastico",
        component: MInput,
        className: "col-md-3 pt-3",
      },
    ],
    [
      {
        id: "grado" + props.idx,
        field: "grado",
        label: "Grado/ordine di svolgimento del servizio",
        payload: { options: this.PAYLOADS.grado },
        component: MSelect,
        readOnly: true,
        className: "col-md-6",
      },
      {
        id: "classeConcorso" + props.idx,
        field: "classeConcorso",
        label: "Classe di Concorso",
        payload: { options: this.PAYLOADS.competitionClass },
        component: MSelect,
        readOnly: true,
        className: "col-md-6",
      },
    ],
    [
      {
        id: "ufficioScolastico" + props.idx,
        field: "ufficioScolastico",
        label: "Codice meccanografico istituto",
        component: MInput,
        className: "col-md-6",
      },
      {
        id: "contactEmail" + props.idx,
        field: "contactEmail",
        label: "E-mail dell’istituto",
        component: MInput,
        className: "col-md-6",
      },
    ],
    [
      {
        id: "city" + props.idx,
        field: "city",
        label: "Comune",
        component: MInput,
        className: "col-md-10",
      },
      {
        id: "province" + props.idx,
        field: "province",
        label: "Provincia (sigla)",
        component: MInput,
        className: "col-md-2",
      },
      {
        id: "address" + props.idx,
        field: "address",
        label: "Via/Piazza",
        component: MInput,
        className: "col-md-12",
      },
    ],
    [
      {
        id: "dateFrom" + props.idx,
        field: "dateFrom",
        label: "dal",
        component: MInput,
        type: "date",
        className: "col-md-4",
      },
      {
        id: "dateTo" + props.idx,
        field: "dateTo",
        label: "al",
        component: MInput,
        type: "date",
        className: "col-md-4",
      },
      {
        id: "durata" + props.idx,
        field: "durata",
        label: "Per un totale di giorni",
        component: MInput,
        type: "text",
        className: "col-md-4",
      },
    ],
    [
      {
        id: "lode" + props.idx,
        field: "lode",
        label: "Fino al termine delle operazioni di scrutinio finale ai sensi dell'articolo 11, comma 14, della legge n. 124 del 1999",
        component: MCheckbox,
        className: "col-md-12",
        onChange: props.onChangeCheck,
      },
    ],
  ];

  static getFieldsShort = (props) => [
    [
      {
        id: "istitution" + props.idx,
        field: "istitution",
        label: "Istituzione Scolastica",
        component: MInput,
        className: "col-md-9 pt-3",
      },
      {
        id: "aa" + props.idx,
        field: "aa",
        label: "Anno Scolastico",
        component: MInput,
        className: "col-md-3 pt-3",
      },
    ],
    [
      {
        id: "grado" + props.idx,
        field: "grado",
        label: "Grado/ordine di svolgimento del servizio",
        payload: { options: this.PAYLOADS.grado },
        component: MSelect,
        readOnly: true,
        className: "col-md-6",
      },
      {
        id: "classeConcorso" + props.idx,
        field: "classeConcorso",
        label: "Classe di Concorso",
        payload: { options: this.PAYLOADS.competitionClass },
        component: MSelect,
        readOnly: true,
        className: "col-md-6",
      },
    ],
    [
      {
        id: "ufficioScolastico" + props.idx,
        field: "ufficioScolastico",
        label: "Codice meccanografico istituto",
        component: MInput,
        className: "col-md-6",
      },
      {
        id: "contactEmail" + props.idx,
        field: "contactEmail",
        label: "E-mail dell’istituto",
        component: MInput,
        className: "col-md-6",
      },
    ],
    [
      {
        id: "city" + props.idx,
        field: "city",
        label: "Comune",
        component: MInput,
        className: "col-md-10",
      },
      {
        id: "province" + props.idx,
        field: "province",
        label: "Provincia (sigla)",
        component: MInput,
        className: "col-md-2",
      },
      {
        id: "address" + props.idx,
        field: "address",
        label: "Via/Piazza",
        component: MInput,
        className: "col-md-12",
      },
    ],
    [
      {
        id: "dateFrom" + props.idx,
        field: "dateFrom",
        label: "dal",
        component: MInput,
        type: "date",
        className: "col-md-4",
      },
    ],
    [
      {
        id: "lode" + props.idx,
        field: "lode",
        label: "Fino al termine delle operazioni di scrutinio finale ai sensi dell'articolo 11, comma 14, della legge n. 124 del 1999",
        component: MCheckbox,
        className: "col-md-12",
        onChange: props.onChangeCheck,
      },
    ],
  ];

  /** VALIDATION */

  static getValidationFull = (context, courseType) => ({
    istitution: (value) => value !== "",
    city: (value) => value !== "",
    grado: (value) => value !== "",
    ufficioScolastico: (value) => value !== "" && value.length === 10,
    classeConcorso: (value) => value !== "" && value !== "-1",
    contactEmail: (value) => value !== "",
    province: (value) => value !== "" && value.length < 4,
    address: (value) => value !== "",
    dateFrom: (value) => this.validateDataFrom(value, context, courseType),
    dateTo: (value) => this.validateDataTo(value, context),
    durata: (value) => this.validateDuration(value, context),
    aa: (value) => this.validateAA(value, context, courseType),
  });

  static getValidationShort = (context, courseType) => ({
    istitution: (value) => value !== "",
    city: (value) => value !== "",
    grado: (value) => value !== "",
    ufficioScolastico: (value) => value !== "" && value.length === 10,
    classeConcorso: (value) => value !== "" || value !== "-1",
    contactEmail: (value) => value !== "",
    province: (value) => value !== "" && value.length < 4,
    address: (value) => value !== "",
    dateFrom: (value) => this.validateDataFrom(value, context, courseType),
    aa: (value) => this.validateAA(value, context, courseType),
  });

  /** ERROR MESSAGES */

  static getErrorMessages = (courseType) => ({
    istitution: "Inserire l'Istituzione universitaria o accademica",
    city: "Inserire l'Istituzione universitaria o accademica",
    aa: courseType === "75" ? "Inserire formato AAAA/AAAA (solo anni dal 2017/2018 al 2024/2025)" : "Inserire formato AAAA/AAAA",
    grado: "Inserire il grado/ordine di svolgimento del servizio",
    ufficioScolastico: "Inserire il codice meccanografico dell'istituto",
    classeConcorso: "Inserire la classe di concorso",
    contactEmail: "Inserire l'email dell'istituto",
    province: "Inserire la provincia",
    address: "Inserire l'indirizzo",
    dateFrom: "Inserire la data di inizio",
    dateTo: "Inserire la data di fine",
    durata: "Inserire il numero di giorni oppure numero di giorni non valido",
  });

  /** VALIDATORS */

  static validateAA = (value, context, courseType) => {
    if (!/^(\d{4})\/(\d{4})$/.test(value)) return false;

    const aa = value.split("/");
    const startYear = parseInt(aa[0]);
    const endYear = parseInt(aa[1]);

    if (endYear > new Date().getFullYear()) {
      return false;
    }

    if (endYear !== startYear + 1) return false;

    //--- verifica solo annualità ammesse ---

    //75: ammessi aa dal 17/18 al 24/25
    if (courseType === "75") {
      if (startYear < 2017 || endYear > 2025) {
        context.setState({ validationError: "Anno scolastico non ammesso." });
        return false;
      }
    } else {
      //77: no date future
      if (endYear > 2026) {
        context.setState({ validationError: "Non è possibile inserire anni scolastici futuri." });
        return false;
      }
    }

    return true;
  };

  static validateDataFrom = (value, context) => {
    const v = formHelper.normalize(value);
    if (!v) return false;

    let regex = /^\d{4}-\d{2}-\d{2}$/;
    if (!v.match(regex)) {
      return false;
    }

    const today = new Date();
    const date = new Date(v);

    if (date > today) {
      context.setState({
        validationError: "Deve essere inserita una data valida precedente ad oggi.",
      });
      return false;
    }

    const aa = formHelper.normalize(context.state.aa);

    if (!aa || /^(\d{4})\/(\d{4})$/.test(aa) === false) {
      context.setState({
        validationError: "Deve essere compilato il campo Anno Scolastico.",
      });
      return false;
    }

    const aaSplit = aa.split("/");
    const startYear = parseInt(aaSplit[0]);
    const endYear = parseInt(aaSplit[1]);

    if (date.getFullYear() < startYear) {
      context.setState({
        validationError: `La data di inizio non può essere precedente al ${aaSplit[0]}.`,
      });
      return false;
    }

    //--- ---

    //--- guardia valida solo se lode=true ---
    if (context.state.currentLode) {
      // per l'ultimo anno non è possibile flaggare la lode
      if (aa === "2025/2026") {
        context.setState({
          validationError: "Per l'anno accademico 25/26 non può essere dichiarato '..fino al termine delle operazioni di scrutinio finale'.",
        });
        return false;
      }

      const firstFebruary = new Date(`${endYear}-02-01 `);

      if (date > firstFebruary) {
        context.setState({
          validationError: `La data di inizio deve essere precedente al 1° febbraio ${aaSplit[1]}.`,
        });
        return false;
      }
    } else {
      const dateFrom = new Date(`${startYear}-09-01 00:00`);
      const dateTo = new Date(`${endYear}-08-31 00:00`);

      if (date < dateFrom || date > dateTo) {
        context.setState({
          validationError: `La data di inizio deve essere compresa tra il 1° settembre ${aaSplit[0]} e il 31 agosto ${aaSplit[1]}.`,
        });
        return false;
      }
    }

    context.setState({ validationError: "" });
    return true;
  };

  static validateDataTo = (value, context) => {
    const v = formHelper.normalize(value);
    if (!v) return false;

    let regex = /^\d{4}-\d{2}-\d{2}$/;
    if (!v.match(regex)) {
      return false;
    }

    const today = new Date();
    const date = new Date(v);

    if (date > today) {
      context.setState({
        validationError: "Deve essere inserita una data valida precedente ad oggi.",
      });
      return false;
    }

    const aa = formHelper.normalize(context.state.aa);
    if (!aa || /^(\d{4})\/(\d{4})$/.test(aa) === false) {
      context.setState({
        validationError: "Deve essere compilato il campo Anno Scolastico.",
      });
      return false;
    }

    const aaSplit = aa.split("/");

    if (date.getFullYear() < parseInt(aaSplit[0]) || date.getFullYear() > parseInt(aaSplit[1])) {
      context.setState({
        validationError: `La data di fine deve essere compresa nell'Anno accademico ${aa}.`,
      });
      return false;
    }

    //--- ---

    const dateFromStr = formHelper.normalize(context.state.dateFrom);
    if (!dateFromStr) {
      return false;
    }
    const dateFrom = new Date(dateFromStr);

    let dateTo = new Date(`${aaSplit[1]}-08-31`);

    if (date < dateFrom || date > dateTo) {
      context.setState({
        validationError: `La data di fine deve essere compresa tra il ${dateHelper.toITDate(dateFrom)} e il ${dateHelper.toITDate(dateTo)}.`,
      });
      return false;
    }

    return true;
  };

  static validateDuration = (durata, context) => {
    let d = typeof durata === "object" && durata !== null ? parseInt(durata.value) : parseInt(durata);
    if (!d) {
      return false;
    }

    const dateFrom = formHelper.normalize(context.state.dateFrom);
    const dateTo = formHelper.normalize(context.state.dateTo);
    if (!dateFrom || !dateTo) return false;

    const diffDays = dayjs(dateTo).diff(dayjs(dateFrom), "day");
    if (isNaN(diffDays)) {
      return false;
    }

    return parseInt(diffDays + 1) === d;
  };
}
